export default "__VITE_ASSET__b4e6002b__"